export { submitUpdatesForm };
import JustValidate from "just-validate";
import SlimSelect from 'slim-select';
import $ from "jquery";
import { contactForm } from "./contact-form";
import { submitUpdateForm } from "./submit-update-form";
import { resetDropdowns, showThankYouModal, getReferralSource } from "./main";

const FORM_SUBMIT_ERROR_MESSAGE =
  "We're unable to submit the form right now. Please try again later.";

const form = document.querySelector("#updates-form");
const contact = document.querySelector("#contact-form");
let validation;
const selectDropdowns = document.querySelectorAll('select');
const customSelect = [];
if (selectDropdowns.length) {
  selectDropdowns.forEach((el) => {
    customSelect.push(new SlimSelect({
      select: el,
      settings: {
        // alwaysOpen: open,
        showSearch: false,
      }
    }))
  })
  window.customSelect = customSelect;
}
if (form) {
  validation = new JustValidate("#updates-form");
  window.updateFormValidation = validation;
  const formError = document.querySelector(".form-error");
  validation
    .addField("#firstName", [
      {
        rule: "required",
        errorMessage: "First name is required",
      },
    ])

    .addField("#lastName", [
      {
        rule: "required",
        errorMessage: "Last name is required",
      },
    ])

    .addField("#email", [
      {
        rule: "required",
        errorMessage: "This field is required. Please input a valid email",
      },
      {
        rule: "email",
      },
    ])

    .addField("#profession", [
      {
        rule: "required",
        errorMessage: "This field is required. Please select a value",
      },
    ])

    .addField("#zip", [
      {
        rule: "required",
        errorMessage: "Please provide ZIP Code",
      },
      {
        rule: "number",
      },
      {
        rule: "minLength",
        value: 5,
      },
      {
        rule: "maxLength",
        value: 10,
      },
    ])

    .addField("#phone", [
      {
        validator: (value) => {
          if (!value.trim()) {
            return true;
          }

          const iti = window.internationalPhoneFields?.["phone"];

          return iti ? iti.isValidNumber() : true;
        },
        errorMessage: "Please enter a valid phone number.",
      },
    ])

    .onFail(() => {
      formError.style.display = "block";
      formError.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    })
    .onValidate(({ isValid }) => {
      if (isValid) {
        formError.style.display = "none";
      }
    })
    .onSuccess(async (event) => {
      formError.style.display = "none";
      event.preventDefault();
      await submitUpdateForm(event.target);
    });
}

function setupCharacterCount(inputSelector, countSelector) {
  const input = document.querySelector(inputSelector);
  const count = document.querySelector(countSelector);

  if (!input || !count) return;

  function updateCount() {
    const max = input.getAttribute("maxlength");
    count.textContent = max
      ? `${input.value.length}/${max}`
      : input.value.length;
  }

  updateCount();
  input.addEventListener("input", updateCount);
}

setupCharacterCount("#city", "#city-count");
setupCharacterCount("#address1", ".address1-count span");
setupCharacterCount("#address2", ".address2-count span");

const professionInput = document.getElementById("profession");
const professionSelect = document.querySelector(".field.custom-select.mb-15");

if (professionSelect && professionInput) {
  professionSelect.querySelectorAll(".select-options li").forEach((option) => {
    option.addEventListener("click", async () => {
      professionSelect.querySelector(".selected-value").textContent =
        option.textContent;

      professionInput.value = option.dataset.value;
      if (validation) {
        await validation.revalidateField("#profession");
      }
    });
  });
}

function getUpdatesFormPayload(formEl) {
  const $form = $(formEl);
  let phone = $form.find("#phone").val()?.trim() || "";
  try {
    const iti = window.internationalPhoneFields?.["phone"];
    if (iti && typeof iti.getNumber === "function") {
      phone = iti.getNumber() || phone;
    }
  } catch (e) { }
  const stateSelect = $form.find(
    ".row.three-cols .field.custom-select .selected-value",
  );
  const professionSelect = $form.find(
    ".field.custom-select.mb-15 .selected-value",
  );
  const stateText = stateSelect.length ? stateSelect.text().trim() : "";
  const professionText = professionSelect.length
    ? professionSelect.text().trim()
    : "";
  return {
    firstName: $form.find("#firstName").val()?.trim() || "",
    lastName: $form.find("#lastName").val()?.trim() || "",
    email: $form.find("#email").val()?.trim() || "",
    PhoneNumber: phone,
    address1: $form.find("#address1").val()?.trim() || "",
    address2: $form.find("#address2").val()?.trim() || "",
    city: $form.find("#city").val()?.trim() || "",
    state: stateText,
    zip: $form.find("#zip").val()?.trim() || "",
    profession: professionText,
  };
}

function getContactFormPayload(formEl) {
  const $form = $(formEl);
  const contactedByRep = $form.find("#field-representative").is(":checked")
    ? "Yes"
    : "No";
  return {
    firstName: $form.find("#field-1-name").val()?.trim() || "",
    lastName: $form.find("#field-2-last").val()?.trim() || "",
    email: $form.find("#email").val()?.trim() || "",
    address1: $form.find("#field-address-one").val()?.trim() || "",
    address2: $form.find("#field-address-two").val()?.trim() || "",
    city: $form.find("#field-city").val()?.trim() || "",
    state: $form.find("#field-state").val()?.trim() || "",
    zip: $form.find("#field-zipcode").val()?.trim() || "",
    profession: $form.find("#profession").val()?.trim() || "",
    specialty: $form.find("#specialty").val()?.trim() || "",
    contactedByRep: contactedByRep,
  };
}

function getRequestFacilityFormPayload(formEl) {
  const $form = $(formEl);
  let phone = $form.find("#phone-hcp").val()?.trim() || "";
  // try {
  //   const facilityIti = window.internationalPhoneFields?.["phone-hcp"];
  //   if (facilityIti && typeof facilityIti.getNumber === "function") {
  //     phone = facilityIti.getNumber() || phone;
  //   }
  // } catch (e) { }
  return {
    firstName: $form.find("#firstName-hcp").val()?.trim() || "",
    lastName: $form.find("#lastName-hcp").val()?.trim() || "",
    email: $form.find("#email-hcp").val()?.trim() || "",
    PhoneNumber: phone,
    address1: $form.find("#facility-address-1-hcp").val()?.trim() || "",
    address2: $form.find("#facility-address-2-hcp").val()?.trim() || "",
    city: $form.find("#facility-city-hcp").val()?.trim() || "",
    state: $form.find("#facility-state-hcp").val()?.trim() || "",
    zip: $form.find("#facility-zip-hcp").val()?.trim() || "",
    profession: $form.find("#title-hcp").val()?.trim() || "",
  };
}

function showFormSubmitError(message) {
  const formError = document.querySelector(".form-error");
  if (formError) {
    formError.textContent = message;
    formError.style.display = "block";
    formError.scrollIntoView({ behavior: "smooth", block: "center" });
  } else {
    alert(message);
  }
}

function handleUpdatesFormSuccess(formEl) {
  const dialog = formEl?.closest("dialog");
  if (dialog && typeof dialog.close === "function") {
    dialog.close();
  }
  formEl.reset();
  document
    .querySelectorAll("#updates-form .custom-select .selected-value")
    .forEach((el) => {
      el.textContent = el.dataset.default || "Choose one";
    });
  document
    .querySelectorAll("#updates-form .custom-select input[type='hidden']")
    .forEach((el) => {
      el.value = "";
    });

  const contactForm = document.querySelector(".contact-form");
  const contactFormSuccess = document.querySelector(".contact-form-success");
  if (contactForm && contactFormSuccess) {
    contactForm.style.display = "none";
    contactFormSuccess.classList.remove("hidden");
  }

  if (formEl.id === "updates-form-hcp") {
    formEl.style.display = "none";
    const requestFacilitySuccess = document.querySelector(
      ".request-facility-success",
    );
    if (requestFacilitySuccess) {
      requestFacilitySuccess.classList.remove("hidden");
    }
  }
}

async function submitUpdatesForm(formEl) {
  if (!formEl) return;
  let data;
  if (formEl.id === "contact-form") {
    data = getContactFormPayload(formEl);
  } else if (formEl.id === "updates-form-hcp") {
    data = getRequestFacilityFormPayload(formEl);
  } else {
    data = getUpdatesFormPayload(formEl);
  }

  const nowIso = new Date().toISOString().replace(/\.\d{3}Z$/, "");
  const values = {
    EmailAddress: data.email,
    FirstName: data.firstName,
    LastName: data.lastName,
    Zip: data.zip,
    OptInDate: nowIso,
    OriginSource: "Pemgarda: Website",
    ReferralSource: getReferralSource(),
    CreateDate: nowIso,
    Status: "Active",
    Address1: data.address1,
    Address2: data.address2,
    City: data.city,
    State: data.state,
    ...(data.profession ? { Profession: data.profession } : {}),
    ...(data.specialty ? { Specialty: data.specialty } : {}),
    ...(data.contactedByRep ? { ContactedByRep: data.contactedByRep } : {}),
    ...(data.phone ? { PhoneNumber: data.phone } : {}),
  };

  return $.ajax({
    url: `/api/hub.php?form=${encodeURIComponent(formEl.id)}`,
    method: "POST",
    timeout: 0,
    contentType: "application/json",
    data: JSON.stringify({ values }),
  })
    .then(function (response) {
      if (response && response.errorcode) {
        showFormSubmitError(FORM_SUBMIT_ERROR_MESSAGE);
        return;
      }
      handleUpdatesFormSuccess(formEl);
    })
    .catch(function () {
      showFormSubmitError(FORM_SUBMIT_ERROR_MESSAGE);
    });
}

if (contact != null) {
  contactForm();
}

